import { compare, multiply } from "dinero.js"

import { toDinero, toMonetaryAmount } from "../../../../../../modules/currency/currencyLib"
import { MonetaryAmount } from "../../../../../../modules/currency/currencyTypes"

import { ExtraServiceDetails } from "../../../createOrderTypes"
import { DeliveryOrderLine } from "../../form/formTypes"

export const calculateClampedAmount = (service: ExtraServiceDetails, seatCount: number) => {
    const raw = multiply(toDinero(service.pricePerSeat), seatCount)
    const min = toDinero(service.minimumPrice)
    const max = toDinero(service.maximumPrice)

    const clamped = compare(raw, min) < 0 ? min : compare(raw, max) > 0 ? max : raw

    return toMonetaryAmount(clamped) satisfies MonetaryAmount
}

export const isServiceAdded = (delivery: { orderLines: DeliveryOrderLine[] }, serviceId: number) =>
    delivery.orderLines.some((p) => p.id === serviceId && p?.isExtraService)
